import { SchoolDistrict } from '../../../model/schoolDistrict.model';
import { Component, OnInit } from '@angular/core';
import { PARTYROLE } from 'src/app/model/region.model';
import { User } from '../../auth/model/user.model';
import { Region } from '../../../model/region.model';
import { UserProfileService } from '../service/user-profile.service';

@Component({
    selector: 'view-user-profile',
    templateUrl: './view-user-profile.component.html',
    styleUrls: ['./view-user-profile.component.scss']
})
export class ViewUserProfileComponent implements OnInit {
    constructor(private userProfileService: UserProfileService) {}

    user: User = {};
    partyRoles: PARTYROLE[] = [];
    regions: Region[] = [];

    promises: Array<any> = [];

    ngOnInit(): void {
        this.getUserProfile();
        Promise.all(this.promises).then((res) => {
            this.getPartyRoles();
            this.getRegionsByPartyId();
        });
    }

    getUserProfile() {
        let deferred = new Promise((resolve, reject) => {
            this.userProfileService.getMyProfile().subscribe((res) => {
                if (res?.user) {
                    this.user = res.user;
                    console.log('got a user profile:' + res.user);
                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getPartyRoles() {
        console.log('checking party roles');
        this.userProfileService.getPartyRoles(this.user!.PERSON!.PARTy!.ID!).subscribe((res) => {
            console.log('got res returned');
            if (res?.partyRoles) {
                this.partyRoles = res.partyRoles;
                console.log('got vu party roles:' + res);
            }
        });
    }

    getRegionsByPartyId() {
        this.userProfileService.getRegionsByPartyId(this.user!.PERSON!.PARTy!.ID!).subscribe((res) => {
            if (res?.regions) {
                this.regions = res.regions;
                console.log('got an assigned vu region:' + res.regions);
            }
        });
    }
}
